import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import TabsVPSsinA from 'sections/about/parts/TabsVPSsinA'

class VPSsinA extends React.Component {


    shouldComponentUpdate() {
        return false
    }

    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #111111;
            padding-top: 30px;            
            @media (max-width: 767px) {
                padding: 80px 20px;
            }
            @media (max-width: 500px) {
                padding: 0 20px;
            }
        `

        const AboutContainer = styled(Container)`
            padding: 50px 0;
            @media (max-width: 500px) {
                padding: 50px 0;
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 20px;
        `
        const Heading2 = styled.h2`
            font-size: 50px;
            font-family: Poppins;
            font-weight: 900;
            color: #fff;
            line-height: 60px;
            text-align: center;
            padding-bottom: 80px;        
        `
        const Heading3 = styled.h3`
            font-size: 40px;
            font-family: Poppins;
            color: #c1eb18;
            line-height: 50px;
            margin: 80px 0 20px 0;
        `
        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #c5c5c5;
            padding-bottom: 30px;
        `
        const ServiceListElement = styled.li`
        list-style: circle;
        color: #fff;
        font-weight: 300;
        font-size: 18px;
        margin: 5px 5px;
        &::before {
            display: inline-block;
            content: '';
            border-radius: 15px;
            height: 15px;
            width: 15px;            
            position: relative;
            bottom: 2.5px;            
            }
        `
        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 50px 10px;
        `

        const Element = styled.div`
              margin-bottom: 20px;
              text-align: center;
              img {
                max-height: 500px;
                max-width: 500px;
                width: 100%;
                height: auto;
              }
              transition: 0.2s;
              &:hover {
                transform: translateY(-10px);
              }
              @media (max-width: 767px) {
                width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
                padding: 0;
                margin: 40px 0;            
                img {
                  max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
                  width: 100vw;        /* Igual que el viewport */
                  height: auto;
                  display: block;       /* Asegura que no tenga espacio extra por inline */          
                }        
              }
            `


        return (
            <Section>
                <AboutContainer>
                    <Row>
                        <Col md={12}>
                            <Heading2>¿Por qué elegir nuestros VPS en Colombia?</Heading2>
                            <Separator />
                            <Text>
                                Nuestros VPS en Colombia ofrecen una solución de alto rendimiento, confiable y escalable para empresas y desarrolladores que buscan velocidad,
                                seguridad y soporte local. Ya sea que te encuentres en Bogotá, Medellín, Cali o Barranquilla, nuestros servidores virtuales privados están diseñados
                                para brindarte baja latencia, tiempos de carga óptimos y una infraestructura de última generación adaptada a las necesidades del mercado colombiano.
                            </Text>
                            <ServiceList>
                                <ServiceListElement>
                                    <b>Protección DDoS avanzada:</b> Mantén tu VPS en Bogotá y Colombia seguro contra ataques, garantizando continuidad para tu negocio.
                                </ServiceListElement>
                                <ServiceListElement>
                                    <b>Soporte 24/7 localizado:</b> Asistencia técnica inmediata en Pereira, Cali, Medellín, y Bogotá, disponible en español.
                                </ServiceListElement>
                                <ServiceListElement>
                                    <b>99.9% Uptime garantizado:</b> Estabilidad para tus aplicaciones en Colombia, ideal para e-commerce y startups.
                                </ServiceListElement>
                                <ServiceListElement>
                                    <b>Ancho de banda no medido:</b> Soporta aplicaciones intensivas en Bogotá, desde streaming hasta big data.
                                </ServiceListElement>
                                <ServiceListElement>
                                    <b>Datacenters optimizados para Colombia:</b> Ubicados en Texas, ofrecen baja latencia para usuarios en Pereira y Cali.
                                </ServiceListElement>
                                <ServiceListElement>
                                    <b>Garantía de 30 días:</b> Prueba tu VPS SSD sin riesgos; si no estás satisfecho, te devolvemos tu dinero.
                                </ServiceListElement>
                            </ServiceList>
                            <Text>
                                Optimiza tu presencia digital con un servidor VPS en Colombia y mejora el rendimiento SEO de tu sitio al estar más cerca de tus usuarios finales. Con planes
                                flexibles y precios competitivos, somos la mejor opción para quienes buscan crecer con tecnología de calidad.
                            </Text>
                            <Heading3>Planes VPS SSD No Administrados en RAID 10</Heading3>
                        </Col>
                    </Row>
                    <Row id="vps">
                        <Col md={6}>
                            <Text>
                                Nuestros VPS no administrados en Bogotá y Colombia te dan libertad total con RAID 10 para máxima velocidad y seguridad. Elige el plan perfecto para tu
                                negocio en Pereira, Cali o Medellín.¡Optimiza tu rendimiento
                                hoy mismo con nuestra oferta! Haz clic para desatar tu potencial.
                            </Text>
                            <ServiceList>
                                <ServiceListElement>
                                    1 dirección IP
                                </ServiceListElement>
                                <ServiceListElement>
                                    AlmaLinux 8 o Ubuntu 22
                                </ServiceListElement>
                                <ServiceListElement>
                                    Potente servidor E5
                                </ServiceListElement>
                                <ServiceListElement>
                                    Recargas de SO ilimitadas
                                </ServiceListElement>
                                <ServiceListElement>
                                    Consola de reinicio
                                </ServiceListElement>
                            </ServiceList>
                        </Col>
                        <Col md={6}>
                            <Element>
                                <GatsbyImage image={this.props.image} alt="Servidor VPS SSD RAID 10 en Bogotá" sizes="(max-width: 767px) 300px, 500px"  />
                            </Element>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <TabsVPSsinA />
                        </Col>
                    </Row>
                </AboutContainer>
            </Section>
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {
          file(relativePath: { eq: "vps-ssd.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 500
              )
            }
          }
        }
      `}
        render={(data) => {
            const image = getImage(data.file.childImageSharp.gatsbyImageData);
            return <VPSsinA image={image} {...props} />;
        }}
    />
);

export default Iconos;
